// أقسام إضافية تُدمج مع الشروط الأساسية — لالتزامات متاجر آبل وجوجل والأطر التنظيمية.
export const TERMS_EXTRA_AR = [
  {
    h: "14. التطبيقات على المتاجر ولا مشتريات داخل التطبيق",
    p: [
      "تطبيقا iOS و Android مجانيان للتحميل ولا يحتويان على أي عملية شراء داخل التطبيق ولا أسعار ولا أزرار اشتراك ولا روابط للشراء. الحساب يُنشئه صاحب العمل ولا يدفع الموظف أي مبلغ داخل التطبيق.",
      "تُبَاع الاشتراكات للشركات فقط بموجب عقد أعمال منفصل خارج المتاجر. لا يُعدّ ذلك تحفيزاً للشراء خارج المتجر ولا يُعرض داخل التطبيقات.",
      "هذه الاتفاقية بينك وبين HELCOO فقط. لا تُعدّ Apple أو Google طرفاً فيها، ولا تتحمل أي منهما أي مسؤولية عن التطبيق أو محتواه أو دعمه، وتنطبق إضافةً إلى ذلك اتفاقية ترخيص المستخدم النهائي (EULA).",
    ],
  },
  {
    h: "15. أذونات الجهاز",
    p: [
      "الكاميرا: للتحقق من الوجه عند تسجيل الحضور أو الانصراف فقط. الموقع: «أثناء الاستخدام» فقط ولحظة التسجيل فقط للتأكد من النطاق الجغرافي للفرع — ولا يوجد تتبّع في الخلفية. الصور: اختياري لاختيار صورة الملف الشخصي أو شعار الشركة. الإشعارات: للتذكير بالحضور والانصراف وقرارات الطلبات.",
      "يمكنك رفض أي إذن أو سحبه من إعدادات نظام جهازك، وسيستمر التطبيق في العمل مع تعطّل الميزة المرتبطة به فقط.",
    ],
  },
  {
    h: "16. العمر والأهلية",
    p: [
      "الخدمة موجّهة لبيئات العمل ولمن أتمّ 18 عاماً، أو 16 عاماً حيث يسمح قانون العمل المحلي وبموافقة الوصي وصاحب العمل. لا نجمع بيانات الأطفال عن قصد، وإذا علمنا بجمع بيانات دون السن نحذفها فوراً.",
    ],
  },
  {
    h: "17. الامتثال التنظيمي الإقليمي",
    p: [
      "تلتزم الخدمة بـ GDPR و UK GDPR، ونظام حماية البيانات الشخصية السعودي (PDPL)، وقانون حماية البيانات الشخصية الإماراتي، وقوانين خصوصية كاليفورنيا (CCPA/CPRA) — ولا نبيع أو نشارك بياناتك الشخصية بالمعنى الوارد فيها.",
      "يقرّ العميل بمسؤوليته عن الامتثال لقوانين العمل ومراقبة الموظفين في بلده، بما يشمّل إشعار الموظفين ومشاورة ممثليهم حيث يُشترط ذلك.",
    ],
  },
  {
    h: "18. توافر الخدمة والدعم",
    p: [
      "نستهدف توافراً شهرياً بنسبة 99.5% مع نوافذ صيانة مُعلَنة مسبقاً. الدعم عبر support@helcoo.uk بزمن استجابة مستهدف يومَي عمل.",
      "قد تتأثر الخدمة بانقطاع الإنترنت أو أعطال مزوّدي البنية التحتية، ولا نتحمل المسؤولية عن أسباب خارجة عن سيطرتنا المعقولة.",
    ],
  },
  {
    h: "19. تسوية النزاعات",
    p: [
      "نسعى لحل أي نزاع ودياً خلال 30 يوماً من الإشعار الكتابي. وإن لم يتحقق ذلك، تختص محاكم المملكة المتحدة، دون المساس بحقك كمستهلك في اللجوء إلى محاكم بلد إقامتك.",
      "لا يمنع هذا أي طرف من طلب إجراء تحفّظي عاجل لحماية بياناته أو حقوق ملكيته الفكرية.",
    ],
  },
];
